export default {
	init() {

		const anketaPage = document.querySelector('.vivi-page-anketa')

		if (!anketaPage) return

		function populateFormFields() {
			const urlSearchParams = new URLSearchParams(window.location.search);

			// let r = urlSearchParams.get('r');
			let e = urlSearchParams.get('e');

			if (!e) {
				e = urlSearchParams.get('amp;e');
			}

			// if (r) {
			// 	r = decodeURIComponent(r);
			// 	r = r.replace(/\+/g, ' ');

			// 	try {
			// 		document.querySelector('[name="url_parameter_value"]').value = r;
			// 	} catch (error) {
			// 		console.error('error')
			// 	}
			// }

			if (e) {
				try {
					document.querySelector('[name="url_parameter_email_value"]').value = e;
				} catch (error) {
					console.error('error 2')
				}
			}
		}

		// Initial call to populate form fields
		populateFormFields();

		// Retry every 2 seconds (2000 milliseconds)
		setInterval(populateFormFields, 2000);

	}
}